type RecordWithId = {
  id: string
}

export function mergeSelectedRecord<T extends RecordWithId>(
  records: T[] | null | undefined | unknown,
  selectedRecord?: T | null
) {
  const normalizedRecords = Array.isArray(records) ? records : []

  if (!selectedRecord) return normalizedRecords
  if (normalizedRecords.some((record) => record.id === selectedRecord.id)) {
    return normalizedRecords
  }

  return [selectedRecord, ...normalizedRecords]
}
